import styled from 'styled-components';
import { RegularFont } from '@components/styled/StyledComponents';
import theme from '@styles/theme';

export const ButtonBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 22px;
`;
export const ImageCrop = styled.div`
    min-height: 200px;
    position: relative;
    margin-top: 18px;
`;
export const Canvas = styled.canvas`
    visibility: hidden;
    position: absolute;
`;
export const Image = styled.img<{ $scale: number }>`
    transform: scale(${({ $scale }) => $scale});
`;
export const TitleBox = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 8px;
`;
export const ScaleWrapper = styled.div``;
export const ScaleTitle = styled(RegularFont)`
    margin-right: 12px;
`;
export const ScaleValue = styled.span`
    color: ${theme.colors.grayFontColor};
`;
export const SliderBox = styled.div`
    width: 100px;
    height: 24px;
    position: relative;
`;
export const SliderRail = styled.div`
    width: 100%;
    height: 5px;
    position: absolute;
    top: calc(50% - 2px);
    border-radius: 4px;
    background-color: ${theme.colors.ultraLightGrayFontColor};
`;
export const ScaleSlider = styled.input`
    width: 100%;
    height: 14px;
    position: absolute;
    top: calc(50% - 6px);
    -webkit-appearance: none;
    background-color: transparent;
    margin: 0;

    &:active {
        cursor: grabbing;
    }

    &:focus {
        outline: none;
    }

    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 14px;
        height: 14px;
        border-radius: 7px;
        background-color: ${theme.colors.blackColor};
        cursor: pointer;
    }
`;
